import React from 'react';
import { motion } from 'framer-motion';

const Testimonials = () => {
  const testimonials = [
    {
      quote: "Research Genie cut our equity memo time by 70%.",
      author: "Sarah J., Senior Analyst",
      company: "Global Investment Partners"
    },
    {
      quote: "The insights are so precise, it's like having a team of analysts at my fingertips.",
      author: "Michael T., Portfolio Manager",
      company: "Horizon Capital"
    },
    {
      quote: "I can focus on making decisions instead of digging through filings.",
      author: "David L., Research Director",
      company: "Everest Funds"
    }
  ];

  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-midnight-navy">
          Trusted by Analysts, Funds, and Researchers Worldwide.
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div 
              key={index}
              className="bg-white p-6 rounded-lg shadow-md"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="text-pale-gold text-4xl mb-4">"</div>
              <p className="text-gray-700 mb-4 italic">
                {testimonial.quote}
              </p>
              <div className="mt-auto">
                <p className="font-semibold text-midnight-navy">{testimonial.author}</p>
                <p className="text-sm text-gray-500">{testimonial.company}</p>
              </div>
            </motion.div>
          ))}
        </div>
        
        <div className="mt-12 flex flex-wrap justify-center items-center gap-8 opacity-70">
          <div className="h-12 w-32 bg-gray-300 rounded"></div>
          <div className="h-12 w-32 bg-gray-300 rounded"></div>
          <div className="h-12 w-32 bg-gray-300 rounded"></div>
          <div className="h-12 w-32 bg-gray-300 rounded"></div>
          <div className="h-12 w-32 bg-gray-300 rounded"></div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
